// extracted by css-extract-rspack-plugin
export default {"wrapper":"ff46cd7","title":"d6f614b","group":"fe1b774","item":"a32aa16","name":"a15e2f9"};